import UploadIcon from "../../components/icons/upload-icon";
import cn from "classnames";
import { useRef } from "react";
import { FileUploader } from "react-drag-drop-files";
import heic2any from "heic2any";

type ImagePickerProps = {
  title?: string;
  className?: string;
  onChange?: (file: any) => void;
  error?: string;
  touched?: boolean;
  value?: any;
  resetValue?: () => void;
};

const fileTypes = ["JPG", "JPEG", "SVG", "PNG", "HEIC"];

const ImagePicker = ({
  title,
  className,
  onChange,
  error,
  touched,
  value,
  resetValue,
}: ImagePickerProps) => {
  const hiddenFileInput = useRef(null);

  const handleClick = () => {
    hiddenFileInput && hiddenFileInput?.current?.click();
  };

  const handleChange = (files: any) => {
    let _images = [];
    Object.entries(files).forEach((file: any) => {
      if (file[1]?.type?.toLowerCase().includes("heic")) {
        var blob = file[1]; //ev.target.files[0];
        heic2any({
          blob: blob,
          toType: "image/jpg",
        })
          .then(function (resultBlob: any) {
            let jpgFile = new File([resultBlob], "heic" + ".png", {
              type: "image/png",
              lastModified: new Date().getTime(),
            });
            _images.push(jpgFile);
          })
          .catch(function (x) {});
      } else {
        _images.push(file[1]);
      }
    });

    setTimeout(() => {
      onChange(_images);
    }, 1000);
  };
  return (
    <div className={cn("mb-2", className)}>
      <h5 className="text-sm font-semibold mb-3"> {title}</h5>
      <div>
        <FileUploader
          handleChange={handleChange}
          name="file"
          types={fileTypes}
          multiple
          classes="!h-[100px]"
        />
      </div>
      {touched && error && (
        <p className="my-2 text-xs text-start text-red">{error}</p>
      )}
      {value.length > 0 && (
        // <div className="mt-3">
        //   <div className="bg-blue inline-flex gap-x-5 px-4 py-1 rounded item-center">
        //     <span className="text-white text-sm">Image selected</span>
        //     <span className="text-white cursor-pointer" onClick={resetValue}>
        //       X
        //     </span>
        //   </div>
        // </div>
        <div className="flex gap-6 py-4 px-4">
          {value?.map((image, index) => (
            <div className="relative group">
              <img alt="" className="h-[100px] w-[100px] object-cover" src={image ?? ""} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default ImagePicker;
